<template>
    <div class="min-h-0 flex flex-col">
        <div
            class="mb-4 items-center rounded bg-yellow-500 p-2 text-[13px] text-white"
        >
            <svg
                class="-mt-1 inline"
                width="18"
                height="17"
                viewBox="0 0 18 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.875 9C0.875 4.5125 4.5125 0.875 9 0.875C13.4875 0.875 17.125 4.5125 17.125 9C17.125 13.4875 13.4875 17.125 9 17.125C4.5125 17.125 0.875 13.4875 0.875 9ZM9 5.875C9.16576 5.875 9.32473 5.94085 9.44194 6.05806C9.55915 6.17527 9.625 6.33424 9.625 6.5V9.625C9.625 9.79076 9.55915 9.94973 9.44194 10.0669C9.32473 10.1842 9.16576 10.25 9 10.25C8.83424 10.25 8.67527 10.1842 8.55806 10.0669C8.44085 9.94973 8.375 9.79076 8.375 9.625V6.5C8.375 6.33424 8.44085 6.17527 8.55806 6.05806C8.67527 5.94085 8.83424 5.875 9 5.875ZM9 12.75C9.16576 12.75 9.32473 12.6842 9.44194 12.5669C9.55915 12.4497 9.625 12.2908 9.625 12.125C9.625 11.9592 9.55915 11.8003 9.44194 11.6831C9.32473 11.5658 9.16576 11.5 9 11.5C8.83424 11.5 8.67527 11.5658 8.55806 11.6831C8.44085 11.8003 8.375 11.9592 8.375 12.125C8.375 12.2908 8.44085 12.4497 8.55806 12.5669C8.67527 12.6842 8.83424 12.75 9 12.75Z"
                    fill="white"
                />
            </svg>
            A student can only be in
            <span class="font-semibold">1 classroom at a time</span>. If you add
            a student to a new classroom, they will be removed from their
            existing classroom
        </div>
        <div
            class="mb-4 flex items-center gap-4 rounded bg-green-500 p-2 text-white"
            v-if="successMessage"
        >
            <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.875 9C0.875 4.5125 4.5125 0.875 9 0.875C13.4875 0.875 17.125 4.5125 17.125 9C17.125 13.4875 13.4875 17.125 9 17.125C4.5125 17.125 0.875 13.4875 0.875 9ZM12.0083 7.48833C12.0583 7.42171 12.0945 7.34576 12.1147 7.26496C12.135 7.18415 12.1388 7.10012 12.1261 7.0178C12.1134 6.93547 12.0844 6.85652 12.0407 6.78558C11.9971 6.71464 11.9396 6.65315 11.8719 6.60471C11.8041 6.55627 11.7273 6.52187 11.6461 6.50352C11.5648 6.48518 11.4807 6.48326 11.3987 6.49789C11.3167 6.51251 11.2385 6.54338 11.1686 6.58868C11.0987 6.63398 11.0385 6.69279 10.9917 6.76167L8.295 10.5367L6.94167 9.18333C6.82319 9.07293 6.66648 9.01283 6.50456 9.01569C6.34265 9.01854 6.18816 9.08414 6.07365 9.19865C5.95914 9.31316 5.89354 9.46765 5.89069 9.62956C5.88783 9.79148 5.94793 9.94819 6.05833 10.0667L7.93333 11.9417C7.99749 12.0058 8.07483 12.0552 8.15999 12.0864C8.24515 12.1176 8.33608 12.1299 8.42647 12.1224C8.51686 12.115 8.60455 12.088 8.68344 12.0432C8.76233 11.9985 8.83054 11.9371 8.88333 11.8633L12.0083 7.48833Z"
                    fill="white"
                />
            </svg>

            <div>
                <span v-html="successMessage" />
            </div>
            <div class="ml-auto p-2" @click="successMessage = null">
                <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.557783 0.558298C0.674971 0.441256 0.833824 0.375515 0.99945 0.375515C1.16508 0.375515 1.32393 0.441256 1.44112 0.558298L5.99945 5.11663L10.5578 0.558298C10.615 0.496893 10.684 0.447641 10.7607 0.413481C10.8373 0.379321 10.9201 0.360953 11.004 0.359472C11.0879 0.357992 11.1713 0.373429 11.2491 0.404863C11.3269 0.436297 11.3976 0.483084 11.457 0.542433C11.5163 0.601782 11.5631 0.672477 11.5946 0.7503C11.626 0.828124 11.6414 0.911481 11.6399 0.995401C11.6385 1.07932 11.6201 1.16208 11.5859 1.23875C11.5518 1.31541 11.5025 1.38441 11.4411 1.44163L6.88278 5.99997L11.4411 10.5583C11.5025 10.6155 11.5518 10.6845 11.5859 10.7612C11.6201 10.8378 11.6385 10.9206 11.6399 11.0045C11.6414 11.0884 11.626 11.1718 11.5946 11.2496C11.5631 11.3275 11.5163 11.3981 11.457 11.4575C11.3976 11.5168 11.3269 11.5636 11.2491 11.5951C11.1713 11.6265 11.0879 11.6419 11.004 11.6405C10.9201 11.639 10.8373 11.6206 10.7607 11.5864C10.684 11.5523 10.615 11.503 10.5578 11.4416L5.99945 6.8833L1.44112 11.4416C1.32264 11.552 1.16593 11.6121 1.00401 11.6093C0.842097 11.6064 0.687609 11.5408 0.573098 11.4263C0.458588 11.3118 0.392994 11.1573 0.390138 10.9954C0.387281 10.8335 0.447383 10.6768 0.557783 10.5583L5.11612 5.99997L0.557783 1.44163C0.440741 1.32444 0.375 1.16559 0.375 0.999965C0.375 0.83434 0.440741 0.675486 0.557783 0.558298Z"
                        fill="white"
                    />
                </svg>
            </div>
        </div>

        <div class="flex items-center gap-4">
            <div class="flex flex-shrink items-center gap-4">
                <div class="">{{ form.selectedStudents.length }} selected</div>
                <div
                    class="link border-l pl-4"
                    @click="form.reset()"
                    v-if="form.selectedStudents.length"
                >
                    clear all
                </div>
            </div>
            <div class="ml-auto w-80">
                <form-search
                    placeholder="Search for student by name"
                    v-model="searchText"
                />
            </div>
        </div>
        <div class="max-h-[365px] flex flex-col min-h-0">
            <form @submit.prevent="submitForm" class="flex flex-col min-h-0 h-full">
                <div class="overflow-y-scroll flex flex-col min-h-0">
                    <easy-data-table
                        class="fixed-height-table table"
                        :headers="headers"
                        :items="existingStudents"
                        :hide-footer="true"
                        :rows-per-page="999"
                        :hide-rows-per-page="true"
                        :search-value="searchText"
                        :loading="loading"
                        buttons-pagination
                    >
                        <template #loading>
                            <div
                                class="flex items-center justify-center p-8 text-gray-650"
                            >
                                <div class="">Loading Students...</div>
                            </div>
                        </template>

                        <template #item-selected="student">
                            <label class="relative flex w-6 items-center gap-2">
                                <input
                                    type="checkbox"
                                    :value="student.id"
                                    v-model="form.selectedStudents"
                                    name="selected_students[]"
                                    class="hidden"
                                />

                                <div
                                    class="mr-4 h-6 w-6 rounded border-transparent bg-gray-100 text-gray-900 hover:cursor-pointer"
                                >
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        v-if="
                                            form.selectedStudents.includes(
                                                student.id
                                            )
                                        "
                                    >
                                        <rect
                                            width="24"
                                            height="24"
                                            rx="4"
                                            fill="url(#paint0_linear_811_5728)"
                                        />
                                        <path
                                            d="M6 12.05C8.12281 13.5167 11.2105 15.68 11.2105 17C12.1754 13.7 14.6842 6.88 17 6"
                                            stroke="white"
                                            stroke-width="1.8"
                                        />
                                        <defs>
                                            <linearGradient
                                                id="paint0_linear_811_5728"
                                                x1="12"
                                                y1="0"
                                                x2="12"
                                                y2="24"
                                                gradientUnits="userSpaceOnUse"
                                            >
                                                <stop stop-color="#0286DC" />
                                                <stop
                                                    offset="1"
                                                    stop-color="#0093F2"
                                                />
                                            </linearGradient>
                                        </defs>
                                    </svg>

                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        v-else
                                    >
                                        <rect
                                            width="24"
                                            height="24"
                                            rx="4"
                                            fill="#F0F1F2"
                                        />
                                    </svg>
                                </div>
                            </label>
                        </template>
                        <template #item-full_name="student">
                            <div class="whitespace-nowrap">
                                {{ student.full_name }}
                            </div>
                        </template>

                        <template #item-status="student">
                            {{
                                student.subscription_active ? "Active" : "Inactive"
                            }}
                        </template>

                        <template #item-provider_level.title="student">
                            <ProviderLevelLabel
                                :providerLevelTitle="student.provider_level.title"
                            />
                        </template>
                        <template #item-active_classroom_name="student">
                            <text-clamp
                                autoResize
                                :max-lines="1"
                                location="middle"
                                :text="student.active_classroom_name"
                            />
                        </template>
                    </easy-data-table>
                </div>
                <div class="">
                    <hr />
                    <div class="mt-4 flex items-center justify-end">
                        <div class="btn btn-transparent" @click="cancel()">
                            Cancel
                        </div>
                        <button
                            :class="
                                'btn' +
                                ' ' +
                                (form.isDirty ? 'btn-primary' : 'btn-disabled')
                            "
                        >
                            Add Students ({{ form.selectedStudents.length }})
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import ProviderLevelLabel from "@/Components/ProviderLevelLabel";
import FormCheckbox from "@/Components/FormCheckbox";
import FormSearch from "@/Components/FormSearch";

export default {
    name: "GroupClassroomAddExistingStudentsForm",
    components: { FormCheckbox, ProviderLevelLabel, FormSearch },
    props: {
        classroom: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            existingStudents: [],
            headers: [
                {
                    text: "",
                    value: "selected",
                    sortable: false,
                    width: 20,
                },
                {
                    text: "Name",
                    value: "full_name",
                    sortable: true,
                },
                {
                    text: "Status",
                    value: "status",
                    sortable: true,
                    width: 50,
                },
                {
                    text: "Level",
                    value: "provider_level.title",
                    sortable: true,
                    width: 50,
                },
                {
                    text: "Classroom",
                    value: "active_classroom_name",
                    sortable: true,
                },
            ],
            form: this.$inertia.form({
                selectedStudents: [],
            }),
            searchText: "",
            loading: true,
            successMessage: "",
        };
    },
    methods: {
        getExitingStudents() {
            let vm = this;
            axios
                .get(
                    route("group.classroom.get-existing-students", {
                        classroom: vm.classroom.id,
                    })
                )
                .then(function (response) {
                    vm.loading = false;
                    vm.existingStudents = response.data;
                });
        },
        submitForm() {
            let vm = this;

            this.$inertia.post(
                route("group.classroom.add-existing-students", {
                    classroom: this.classroom.id,
                }),
                {
                    studentIds: this.form.selectedStudents,
                },
                {
                    onSuccess() {
                        vm.successMessage =
                            vm.form.selectedStudents.length +
                            " students have been added to your class";

                        setTimeout(function () {
                            vm.successMessage = null;
                        }, 2000);

                        vm.existingStudents = [];
                        vm.loading = true;
                        vm.form.reset();
                        vm.getExitingStudents();
                    },
                }
            );
        },
        cancel() {
            this.form.reset;
            this.$emit("cancel");
        },
    },
    created() {
        this.getExitingStudents();
    },
};
</script>
